import { Button, Form, Input, Select } from 'antd';
import { useDispatch } from 'react-redux';
import { setSearchBrandedFixture } from '../../branded-fixtures/branded-fixtures-actions';

function SearchBrandedFixtures() {
  const dispatch = useDispatch();
  const [form] = Form.useForm();

  const onSubmit = (formData: any) => {
    const searchDetails = {
      fixtureName: formData?.fixtureName || '',
      vendorName: formData?.vendor || '',
      collection: formData?.collection || '',
      isGeneric: formData?.isGeneric,
      page: 0,
      size: 15,
    };
    dispatch(setSearchBrandedFixture(searchDetails));
  };

  return (
    <div className='search-container'>
      <Form
        form={form}
        layout='vertical'
        className='search-container'
        onFinish={(formData) => {
          onSubmit(formData);
        }}
      >
        <Form.Item key='vendor' label='Product Vendor' name='vendor' className='label-text input-field'>
          <Input allowClear style={{ width: '160px' }} placeholder='Enter product vendor' />
        </Form.Item>
        <Form.Item key='collection' label='Collection' name='collection' className='label-text input-field'>
          <Input allowClear style={{ width: '160px' }} placeholder='Enter collection' />
        </Form.Item>
        <Form.Item key='isGeneric' label='Generic Type' name='isGeneric' className='label-text input-field'>
          <Select
            allowClear
            style={{ width: '120px' }}
            placeholder='Select'
            options={[
              { value: true, label: 'Yes' },
              { value: false, label: 'No' },
            ]}
          />
        </Form.Item>
        <Form.Item key='fixtureName' label='Fixture Name' name='fixtureName' className='label-text input-field'>
          <Input allowClear style={{ width: '160px' }} placeholder='Enter fixture name' />
        </Form.Item>
        <Form.Item className='search-btn'>
          <Button type='primary' htmlType='submit'>
            SEARCH
          </Button>
        </Form.Item>
      </Form>
    </div>
  );
}

export default SearchBrandedFixtures;
